/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * Current account state for bill generation
 */
export type BillGenerationState =
  (typeof BillGenerationState)[keyof typeof BillGenerationState]

export const BillGenerationState = {
  noBillNewAccount: "noBillNewAccount",
  billSentWithin31Days: "billSentWithin31Days",
  noBillWithin31Days: "noBillWithin31Days",
  billingSuppressed: "billingSuppressed",
  noBillAndBillingRecentlyUnsuppressed: "noBillAndBillingRecentlyUnsuppressed",
  finalBillSent: "finalBillSent",
  unknown: "unknown",
  noBillWithin36Days: "noBillWithin36Days",
} as const
